import React, { useState } from 'react';

import JSONEditorReact from './JSONEditorReact';

const modes = ['tree', 'form', 'view', 'code', 'text'];

const CustomJsonEditor = ({ json, handleChangeText }: { json: string; handleChangeText: any }) => {
	const [mode, setMode] = useState(modes[0]);

	const onModeChange = (newMode: string) => {
		setMode(newMode);
	};

	return (
		<div style={{ height: '600px', width: '100%' }}>
			<JSONEditorReact
				text={json !== '' ? json : JSON.stringify({})}
				mode={mode}
				modes={modes}
				indentation={4}
				onChangeText={handleChangeText}
				onModeChange={onModeChange}
			/>
		</div>
	);
};

export default CustomJsonEditor;
